<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="(size*11)/17"
    viewBox="0 0 17 11"
  ><g><g><path
    :fill="color"
    d="M14.23 6.137h-1.283l.104-2.475.023.002h1.156c.597 0 1.083.554 1.083 1.236 0 .682-.486 1.237-1.083 1.237zM3.984 8.727c-1.086 0-1.978-.97-2.03-2.21L1.75 1.612h10.345l-.204 4.907c-.052 1.239-.943 2.21-2.03 2.21zm9.116-6.25l.06-1.432a.644.644 0 0 0-.143-.437.491.491 0 0 0-.376-.184H1.205a.491.491 0 0 0-.377.184.644.644 0 0 0-.143.437l.231 5.53c.057 1.366.79 2.515 1.82 3.038H.52c-.287 0-.52.266-.52.593 0 .328.233.594.52.594h12.879c.287 0 .52-.266.52-.594 0-.327-.233-.593-.52-.593h-2.29c.835-.424 1.474-1.26 1.717-2.289h1.404c1.17 0 2.123-1.087 2.123-2.424 0-1.336-.952-2.424-2.123-2.424z"
  /></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
